module.exports = __webpack_public_path__ + "img/weddings_34_H.c31c6f07.webp";